import { Grid, Paper, Skeleton, Stack } from '@atgfr8/atg-ui-tailwind';
import { AlertOutlineIcon } from '@atgfr8/icons';
import { For, mergeProps, splitProps } from 'solid-js';
type SkeletonVariant = 'text' | 'circular' | 'rectangular';

export interface PlaceholderProps {
  variant: SkeletonVariant;
  height?: number;
  width?: number;
  count?: number; // Optional, default to 1
  size?: {
    width: number;
    height: number;
  };
}

export function Placeholder(props: PlaceholderProps) {
  const defaultProps = { count: 1 };
  const mergedProps = mergeProps(defaultProps, props);
  const [local, skeletonProps] = splitProps(mergedProps, ['count']);

  const skeletons = Array.from({ length: local.count });

  return (
    <Stack spacing={1}>
      <For each={skeletons}>
        {() => (
          <Skeleton
            variant={skeletonProps.variant}
            height={skeletonProps.height}
            width="100%"
            class="mb-2"
          />
        )}
      </For>
    </Stack>
  );
}

export function WarningPlaceholder(props: { message: string }) {
  return (
    <>
      <Paper class="bg-[#F2DEDE]">
        <Grid container height={'100px'} alignItems="center" paddingLeft={4}>
          <Grid item size={1}>
            <AlertOutlineIcon size={50} color="red" />
          </Grid>
          <Grid item size={11} color="red">
            {props.message}
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}

export function CardPlaceholder() {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item size={12}>
          <Placeholder variant="text" height={60} />
          <Placeholder variant="rectangular" height={40} />
        </Grid>
        <Grid item size={6}>
          <Placeholder variant="text" height={60} />
          <Placeholder variant="rectangular" height={40} />
        </Grid>
        <Grid item size={6}>
          <Placeholder variant="text" height={60} />
          <Placeholder variant="rectangular" height={40} />
        </Grid>
        <Grid item size={12}>
          <Placeholder variant="text" height={60} />
          <Placeholder variant="rectangular" height={40} />
        </Grid>
      </Grid>
    </>
  );
}

export function AddressCardPlaceholder() {
  return (
    <>
      <Grid container spacing={1}>
        <Grid item size={12}>
          <Placeholder variant="text" height={60} />
          <Placeholder variant="rectangular" height={40} />
        </Grid>
        <Grid item size={6}>
          <Placeholder variant="text" height={60} />
        </Grid>
        <Grid item size={6}>
          <Placeholder variant="text" height={60} />
        </Grid>
      </Grid>
    </>
  );
}

export function TextPlaceholder() {
  return (
    <Placeholder variant="text" size={{ width: 210, height: 18 }} count={3} />
  );
}

export function CircularPlaceholder() {
  return (
    <Placeholder
      variant="circular"
      size={{ width: 40, height: 40 }}
      count={3}
    />
  );
}
